import {
  Button,
  Card,
  Checkbox,
  Flex,
  Form,
  Input,
  Layout,
  Select,
  SelectProps,
  Spin,
  Timeline,
  Typography,
} from 'antd';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import iconRoute from '../../assets/images/segments/icon-route.svg';
import StepSchedules from '../../components/StepSchedules';
import { TYPE_PRICE_UP } from '../../config/constant';
import { Message } from '../../config/message';
import { convertOptionCheckBox } from '../../lib/utils';
import { useAppDispatch, useAppSelector } from '../../redux/hooks';
import { getAllAvailableBusType, listBusTypeSelector } from '../../redux/slice/busTypes/listBusTypeSlice';
import { fetchListRoute, getAllRoute, routeSelector } from '../../redux/slice/routeSlice';
import {
  getAllProvinces,
  ListScheduleSelector,
  setIdSeatMap,
  setListSeatMap,
  setListSegment,
  setListTransships,
  setUpdateSegment,
} from '../../redux/slice/schdules/scheduleSlice';
import { getDiffDay } from '../../utils/helpers';
import { listColor } from '../../utils/listColorItem';
import SegmentSettingModal from './ModalSchedules/SegmentSettingModal';
import SeatMapSegment from './SeatMapRender/SeatMapSegment';

function SegmentSetting() {
  const { t } = useTranslation();
  const { loading: loadingRoute } = useAppSelector(routeSelector);
  const {
    listSegment,
    listScheduleDetail,
    isDetailSchedule,
    loadingDetail,
    isUpdatedSegment,
    listTransships,
    idSeatMap,
  } = useAppSelector(ListScheduleSelector);
  const { listAllRoute } = useAppSelector(routeSelector);
  const { listAllAvailableBusType } = useAppSelector(listBusTypeSelector);
  const [form] = Form.useForm();
  const [keywordBus, setKeywordBus] = useState<any>({});
  const [openModalSegment, setOpenModalSegment] = useState<boolean>(false);
  const [isActive, setIsActive] = useState<boolean>(false);
  const [routeActive, setRouteActive] = useState<any>();
  const [seatRender, setSeatRender] = useState<any>();
  const [allSeatName, setAllSeatName] = useState<any>();
  const [seatData, setSeatData] = useState<any>();
  const [groupSeat, setGroupSeat] = useState<any>();
  const [segmentTimelineItem, setSegmentTimelineItem] = useState<any>([]);
  const [keyword, setKeyword] = useState<any>({});
  const watchRoute = Form.useWatch('route_id', form);
  const navigate = useNavigate();

  const dispatch = useAppDispatch();

  const RouteRules = [
    {
      required: true,
      message: t(Message.ROUTE),
    },
  ];
  const BusTypeRules = [
    {
      required: true,
      message: t('Vui lòng chọn loại xe'),
    },
  ];
  function onSearchRoute(value: any) {
    setKeyword(value);
  }
  function onSearchBusType(value: any) {
    setKeywordBus(value);
  }
  const filterOptionRoute = (
    input: string,
    option?: {
      label: string;
      value: string;
    },
  ) => (option?.label ?? '').toLowerCase()?.includes(input.toLowerCase());
  const filterOptionBus = (
    input: string,
    option?: {
      label?: any;
      value?: any;
      seatMap?: any;
    },
  ) => (option?.label ?? '').toLowerCase()?.includes(input.toLowerCase());

  const BusOptions: SelectProps['options'] = listAllAvailableBusType?.length
    ? listAllAvailableBusType?.map((item: any) => {
        return {
          value: item?.id,
          label: item?.name,
          seatMap: item?.seat_map,
        };
      })
    : [];
  const findColor = (keyIndex: number, groupSeat: any) => {
    const item = groupSeat?.find((_: any, index: any) => +index === +keyIndex);
    return item ? item?.group_color : 'default';
  };
  const scrollToErrorField = (errorFields: any) => {
    const [firstErrorField] = errorFields;
    if (firstErrorField) {
      form.scrollToField(firstErrorField.name);
    }
  };
  function onChangeGroup(values: any, option: any) {
    form.setFieldsValue({ agent_seats: [] });
    form.setFieldsValue({ seat_count: option?.seatMap?.seat_number });
    form.setFieldsValue({ seat_map: option?.seatMap });
    setSeatRender(option?.seatMap);
    setGroupSeat(option?.seatMap?.group_seat);
    let seatDataOption: any = [];
    let dataOption: any = [];
    option?.seatMap?.group_seat?.map((item: any) => {
      return (seatDataOption = [...seatDataOption, ...item.selected_seat]);
    });
    dispatch(setListSeatMap(option?.seatMap));
    dispatch(setIdSeatMap(values));
    setSeatData(seatDataOption);
    convertOptionCheckBox(dataOption, [...seatDataOption]?.sort());
    setAllSeatName(dataOption);
    form.setFieldsValue({ agent_seats: seatDataOption });
  }
  const handleChangeRoute = (value: any, option: any) => {
    setRouteActive(option?.routeItem);
    setIsActive(false);
  };
  const onFinish = (values: any) => {
    values.is_depart_transship = values.is_depart_transship ?? false;
    values.is_arrive_transship = values.is_arrive_transship ?? false;
    const formattedSegments = { ...listSegment, ...values };
    dispatch(setListSegment(formattedSegments));
    const createTransshipItem = (segmentName: string) => ({
      is_depart: false,
      is_arrive: false,
      is_extra_price_arrive: TYPE_PRICE_UP,
      is_extra_price_depart: TYPE_PRICE_UP,
      extra_price_value_depart: 0,
      extra_price_value_arrive: 0,
      pickup_time: undefined,
      diff_day: 0,
      name: segmentName,
      pickup_location_id: undefined,
    });
    const initialItems = Object.fromEntries(
      listSegment?.segment?.map((segmentItem: any, index: number) => [
        String(index + 1),
        [createTransshipItem(segmentItem?.name)],
      ]) || [],
    );
    const allIds = Object.values(listTransships)?.flatMap((group: any) =>
      group.map((item: any) => item?.pickup_location_id),
    );
    if (listSegment?.segment?.length) {
      if (isDetailSchedule) {
        dispatch(setUpdateSegment(true));
      }
      if (!allIds?.length) {
        dispatch(setListTransships(initialItems));
      }
      if (!idSeatMap && isDetailSchedule) {
        dispatch(setIdSeatMap(listScheduleDetail?.bus_type?.id));
      }
      navigate('/bus-management/schedules/locations');
    } else {
      toast.error('Vui lòng thiết lập chặng');
    }
  };
  useEffect(() => {
    if (listSegment?.depart_point && listSegment?.arrive_point) {
      setSegmentTimelineItem([
        ...(listSegment?.segment?.length
          ? listSegment?.segment?.map((segment: any, index: number) => ({
              children: (
                <Flex gap={8} key={index} className="block-bg-color items-center">
                  <p
                    className={`hour-time-line color ${listColor[(index + 1) % listColor?.length]}`}
                    style={{ width: '50px' }}
                  >
                    {segment?.arrive_time}
                  </p>
                  <div className={`btn-time-line ${listColor[(index + 1) % listColor?.length]}`}>{segment?.name}</div>
                  <p className="fs-14 fw-500" style={{ color: '#4F5662' }}>{`${getDiffDay(segment?.diff_day)}`}</p>
                </Flex>
              ),
              dot: (
                <div className="block-color">
                  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                    <circle
                      cx="8"
                      cy="8"
                      r="6"
                      strokeWidth="4"
                      className={listColor[(index + 1) % listColor?.length]}
                    />
                  </svg>
                </div>
              ),
            }))
          : []),
      ]);
    }
    if (listSegment?.route_id || listSegment?.bus_type_id) {
      form.setFieldsValue({
        is_depart_transship: listSegment?.is_depart_transship,
        is_arrive_transship: listSegment?.is_arrive_transship,
        route_id: listSegment?.route_id,
        bus_type_id: listSegment?.bus_type_id,
        seat_map: listSegment?.seat_map?.count_floor ? listSegment?.seat_map : undefined,
      });
      setSeatRender(listSegment?.seat_map?.count_floor ? listSegment?.seat_map : undefined);
      setGroupSeat(listSegment?.seat_map?.group_seat ? listSegment?.seat_map?.group_seat : undefined);
    }
  }, [listSegment]);
  useEffect(() => {
    if (listScheduleDetail && isDetailSchedule && !isUpdatedSegment) {
      const formattedSegments = listScheduleDetail?.segments?.stops?.map((segment: any, index: number) => ({
        ...segment,
        no: index + 1,
      }));
      const segmentData = {
        depart_point: listScheduleDetail?.route?.depart_point,
        depart_id: listScheduleDetail?.route?.depart_province?.id,
        travel_time: listScheduleDetail?.travel_time,
        depart_time: listScheduleDetail?.depart_time?.slice(0, 5),
        arrive_point: listScheduleDetail?.route?.arrive_point,
        arrive_id: listScheduleDetail?.route?.arrive_province?.id,
        segment: formattedSegments,
        arrive_time: listScheduleDetail?.arrive_time?.slice(0, 5),
      };
      dispatch(setListSegment(segmentData));
      dispatch(setListSeatMap(listScheduleDetail?.bus_type?.seat_map));
      form.setFieldsValue({
        is_depart_transship: listScheduleDetail?.is_depart_transship,
        is_arrive_transship: listScheduleDetail?.is_arrive_transship,
        route_id: listScheduleDetail?.route?.id,
        bus_type_id: listScheduleDetail?.bus_type?.id,
        seat_map: listScheduleDetail?.bus_type?.seat_map?.count_floor
          ? listScheduleDetail?.bus_type?.seat_map
          : undefined,
      });
      setSeatRender(listScheduleDetail?.bus_type?.seat_map);
      setGroupSeat(listScheduleDetail?.bus_type?.seat_map?.group_seat);
    }
  }, [isDetailSchedule, listScheduleDetail, isUpdatedSegment]);
  useEffect(() => {
    dispatch(getAllAvailableBusType({ keyword: keywordBus }));
  }, [dispatch, keywordBus]);

  useEffect(() => {
    dispatch(fetchListRoute({}));
  }, [dispatch]);

  useEffect(() => {
    dispatch(getAllRoute({}));
  }, [dispatch]);

  useEffect(() => {
    dispatch(getAllProvinces());
  }, [dispatch]);

  return (
    <Layout className="min-vh-70 segment-booking ">
      <Spin spinning={isDetailSchedule ? loadingDetail : false}>
        <Card>
          <Form
            layout="vertical"
            form={form}
            onFinish={onFinish}
            autoComplete="off"
            validateTrigger="onSubmit"
            labelCol={{ span: 12 }}
            colon={false}
            labelAlign={'left'}
            initialValues={{
              is_depart_transship: false,
              is_arrive_transship: false,
            }}
            labelWrap
            onFieldsChange={(allFields) => {
              scrollToErrorField(allFields.filter((field) => field.errors && field.errors.length > 0));
            }}
          >
            <StepSchedules step={1} />
            <div className="segment-block">
              <div className="mt-4 border-b-segment pb-3">
                <Flex gap={16}>
                  <img src={iconRoute} alt="" />
                  <div>
                    <Typography.Text className="fw-600 fs-18 title-segment">Thiết lập chặng</Typography.Text>
                    <br />
                    <Typography.Text>Xác định điểm bắt đầu, điểm dừng và điểm kết thúc cho hành trình.</Typography.Text>
                  </div>
                </Flex>
              </div>
              <Form.Item name="seat_map" className="d-none">
                <Input />
              </Form.Item>
              <div className="segment-content flex mt-4">
                <div className="route">
                  <div className="fs-16 fw-600 text-white title">Tuyến</div>
                  <Flex gap={12} justify="start" align="center">
                    <Form.Item
                      name="route_id"
                      className="form-item-name route-select mt-3"
                      validateTrigger={['onChange', 'onBlur']}
                      rules={RouteRules}
                    >
                      <Select
                        className="input-h40 w-100"
                        loading={loadingRoute}
                        showSearch
                        placeholder="Chọn tuyến"
                        onSearch={onSearchRoute}
                        filterOption={filterOptionRoute}
                        onChange={(value, option) => handleChangeRoute(value, option)}
                        size="large"
                        disabled={isDetailSchedule}
                        options={
                          listAllRoute?.length
                            ? listAllRoute?.map((item) => {
                                return {
                                  value: item?.id,
                                  label: `${item?.depart_point} - ${item?.arrive_point} ${
                                    item?.note ? ` (${item?.note})` : ''
                                  }`,
                                  routeItem: item,
                                };
                              })
                            : []
                        }
                      />
                    </Form.Item>
                  </Flex>
                  <Flex gap={28} className="transship-block">
                    <Form.Item name="is_depart_transship" valuePropName="checked">
                      <Checkbox>
                        <Typography className="fw-500">Trung chuyển đón</Typography>
                      </Checkbox>
                    </Form.Item>
                    <Form.Item name="is_arrive_transship" valuePropName="checked">
                      <Checkbox>
                        <Typography className="fw-500">Trung chuyển trả</Typography>
                      </Checkbox>
                    </Form.Item>
                  </Flex>
                  <div className="border-b" style={{ paddingBottom: '20px' }}>
                    <Button
                      htmlType="button"
                      className={`btn-setting mt-2 fs-16 fw-600 ${watchRoute ? 'active' : ''} `}
                      onClick={() => {
                        if (watchRoute) {
                          setOpenModalSegment(true);
                          setIsActive(true);
                        }
                      }}
                    >
                      Thiết lập chặng
                    </Button>
                  </div>
                  <Timeline
                    className="mt-4 block-color"
                    items={segmentTimelineItem?.length > 0 ? segmentTimelineItem : []}
                  />
                </div>
                <div className="bus-type">
                  <div className="fs-16 fw-600 text-white title">Loại xe</div>
                  <Form.Item
                    name="bus_type_id"
                    className="form-item-name bustype-select required mt-3"
                    validateTrigger={['onChange', 'onBlur']}
                    rules={BusTypeRules}
                  >
                    <Select
                      className="input-h40"
                      showSearch
                      placeholder="Loại xe"
                      onChange={(value: any, option: any) => onChangeGroup(value, option)}
                      onSearch={onSearchBusType}
                      filterOption={filterOptionBus}
                      options={BusOptions}
                      disabled={listScheduleDetail?.has_booking}
                    />
                  </Form.Item>
                  <div className="mt-2">
                    {seatRender?.count_floor && (
                      <div key="segment-bus_type">
                        <Flex className="mt-2" align="center" gap={28}>
                          {groupSeat?.length > 0 &&
                            groupSeat?.map((item: any, index: number) => (
                              <Flex align="center" gap={8} key={`group-seat-${index}`}>
                                <div className={`block-color-seat ${findColor(index, groupSeat)}`}></div>
                                <span className="block-color-name">{`${item?.name}`}</span>
                              </Flex>
                            ))}
                        </Flex>
                        <div className="seat-render-custom mt-2">
                          <SeatMapSegment
                            column={seatRender?.column ?? 0}
                            row={seatRender?.row ?? 0}
                            seatCount={seatRender?.count_floor}
                            seatMatrixData={seatRender}
                          />
                        </div>
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </div>
            <SegmentSettingModal
              modalOpen={openModalSegment}
              onCancel={() => {
                setOpenModalSegment(false);
                setIsActive(false);
              }}
              onOk={() => {}}
              isActive={isActive}
              isDetailSchedule={isDetailSchedule}
              routeActive={routeActive}
            />
          </Form>
        </Card>
      </Spin>
    </Layout>
  );
}

export default SegmentSetting;
